export const drawerWidth = 200;
export const miniWidth = 48;

const config = {
    defaultPath: '/',
    fontFamily: `'Public Sans', sans-serif`,
    i18n: 'en',
    miniDrawer: false,
    container: false,
    mode: 'dark',
    presetColor: 'default',
    themeDirection: 'ltr',
};

export default config;